import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ChartList from './list/index';
import PageError from '../error/pageError';

export default class ChartsOrganization extends React.Component {
    render() {
        const { path, organization } = this.props;

        return (
            <Switch>
                <Route exact path={`${path}/`} render={() => <ChartList organization={organization} />} />
                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
            </Switch>
        );
    }
}

ChartsOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
